import { each, debounce, throttle } from "lodash";

declare const jQuery: any;
const $ = jQuery;
const $window = $(window);

const dfAnimDuration = 0.4;

export function init(): void
{
	$('.image-slider').each(function () {
		initSlider($(this));
	});
}

function initSlider($wrap): void
{
	const $items = $wrap.find(".image-slider-item");
	const $slider = $wrap.find(".image-slider-items");
	setupSliderPositionCorrection($slider, $items);
	setupItemPositionCorrection($wrap);
	onImagesLoaded($items, () => {
		revealSlider($slider);
		setupTransitions($wrap);
	});
}

function onImagesLoaded($items, onLoaded: Function): void
{
	const numTotal: number = $items.length;
	let numComplete: number = 0;
	const itemCompleted = () => {
		++numComplete;
		if (numComplete >= numTotal)
		{
			onLoaded();
		}
	};
	$items.each(function () {
		const url: string = $(this).attr(`data-url`);
		if (!url)
		{
			itemCompleted();
			return;
		}
		const image = new Image();
		image.onload = image.onerror = itemCompleted;
		image.src = url;
	});
}

function revealSlider($slider)
{
	$slider.css({ opacity: 1 });
}

function setupItemPositionCorrection($wrap): void
{
	const correct = () => {
		const $items = $wrap.find(".image-slider-item");
		const numItems: number = $items.length;
		const w: number = $items.outerWidth();
		$items.each(function (index) {
			$(this).css({ left: w * index });
		});
	};
	correct();
	$window.on("resize load", throttle(correct, 100));
}

function setupSliderPositionCorrection($slider, $items): void
{
	const $container = $slider.parent();
	const numItems: number = $items.length;
	const correct = () => {
		const windowWidth: number = $window.outerWidth();
		$items.css({ width: "" });
		if ($items.first().outerWidth() > windowWidth)
		{
			$items.css({ width: windowWidth });
		}
		const containerWidth: number = $container.outerWidth();
		const itemWidth: number = $items.outerWidth();
		const left: number = ((numItems / 2) * -itemWidth) + ((containerWidth / 2) - (itemWidth / 2));
		$slider.css({ left, width: itemWidth * numItems });
	};
	correct();
	$window.on("resize load", throttle(correct, 100));
}

function setupTransitions($wrap): void
{
	let disabled = false;
	let timer: any;

	const animDuration: number = (parseFloat($wrap.attr("data-slide-duration")) || dfAnimDuration) * 1000;
	const wait: number = (parseFloat($wrap.attr("data-wait")) || 0) * 1000;

	function move(direction: "-"|"+"): void
	{
		if (disabled)
		{
			return;
		}
		clearTimeout(timer);
		disabled = true;
		const $items = $wrap.find(".image-slider-item");
		const itemWidth: number = $items.outerWidth();
		$items.stop(true).animate({ left: direction + "=" + itemWidth }, animDuration, function () {
			clearTimeout(timer);
			const itemWidth: number = $items.outerWidth();
			if (direction === "-")
			{
				$items.first().css({ left: parseInt($items.last().css("left"), 10) + itemWidth }).appendTo($items.parent());
			}
			else
			{
				$items.last().css({ left: parseInt($items.first().css("left"), 10) - itemWidth }).prependTo($items.parent());
			}
			disabled = false;
			if (wait)
			{
				timer = setTimeout(next, wait);
			}
		});
	}

	function next(): void // move left
	{
		move("-");
	}

	function prev(): void // move right
	{
		move("+");
	}

	$wrap.find(".image-slider-chevron-prev").click(prev);
	$wrap.find(".image-slider-chevron-next").click(next);

	if (wait)
	{
		timer = setTimeout(next, wait);
	}
}
